<div class="row" *ngIf="user$ | async as user">
    <div class="col-md-8 offset-md-2" *ngIf="!user.active">
        <div class="card">
            <div class="card-body p-0">
                <div class="alert alert-danger border-0 rounded-0 m-0 d-flex align-items-center" role="alert">
                    <i-feather name="alert-triangle" class="text-danger me-2 icon-sm"></i-feather>
                    <div class="flex-grow-1 text-truncate">
                        Your account is <b>INACTIVE</b>.
                    </div>

                    <div class="flex-shrink-0">
                        <a href="javascript:;" (click)="requestActivation()"
                            class="text-reset text-decoration-underline">
                            <b>Request Activation</b>
                        </a>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-sm-10">
                        <div class="p-3">
                            <p class="fs-16 lh-base">
                                To fully use the portal you will need to Activate your account.
                            </p>
                            <p class="fs-16 lh-base">
                                If you didn't receive an Activation Email, click <strong>Request
                                    Activation</strong> above to receive a new welcome email
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="action-mail-icon-container">
                            <lord-icon src="https://cdn.lordicon.com/eqbqgqho.json" trigger="morph" [colors]="colors"
                                style="width:120px; height:120px">
                            </lord-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mb-3 pb-1" *ngIf="user$ | async as user">
    <div class="col-12">
        <div class="d-flex align-items-lg-center flex-lg-row flex-column">
            <div class="flex-grow-1">
                <h4 class="fs-16 mb-1">
                    {{ 'APP.WELCOME.USER' | translate:{name:user.firstName} }}
                </h4>
                <p class="text-muted mb-0">{{ 'APP.WELCOME.SUMMARYBUSINESS' | translate }}</p>
                <small class="text-muted mb-0 text-light" *ngIf="range.value.date as dates">{{dates.from |
                    date:'mediumDate'}} &ndash; {{dates.to | date:'mediumDate'}}</small>
            </div>
            <div class="quick-cta-top">
                <div class="cta-row">
                    <button type="button" class="btn btn-outline-primary" (click)="newTransaction()">
                        <i class="bx bx-credit-card fs-20 align-middle"></i> &nbsp; New Transaction
                    </button>

                    <button type="button" class="btn btn-outline-primary" (click)="payContractor()">
                        <i class=" bx bx-user fs-20 align-middle"></i> &nbsp; Pay Contractor
                    </button>

                    <button type="button" class="btn btn-primary" (click)="postLoad()">
                        <i class="las la-box fs-20 align-middle"></i> &nbsp; Create Order
                    </button>
                </div>
                <div class="row g-3 mb-0 align-items-center justify-content-end" [formGroup]="range">
                    <div class="col-sm-auto">
                        <strong>Timeframe:</strong>
                    </div>
                    <div class="col-sm-auto">
                        <div class="input-group input-group-sm" formGroupName="date">
                            <input class="form-control flatpickr-input timeframe-filter" type="text" mwlFlatpickr
                                [monthSelectorType]="'dropdown'" formControlName="from" [altInput]="true"
                                [disableMobile]="true" dateFormat="m/d/y" (flatpickrReady)="onReady('from', $event)"
                                [options]="{utc: true}" [defaultValue]="range.value.date?.from"
                                [convertModelValue]="true">
                            <span class="input-group-text"> - </span>
                            <input class="form-control flatpickr-input timeframe-filter" type="text" mwlFlatpickr
                                [monthSelectorType]="'dropdown'" formControlName="to" [altInput]="true"
                                [disableMobile]="true" dateFormat="m/d/y" (flatpickrReady)="onReady('to', $event)"
                                [options]="{utc: true}" [defaultValue]="range.value.date?.to"
                                [convertModelValue]="true">
                            <span class="input-group-text">
                                <div class="dropdown filter-dropdown" ngbDropdown>
                                    <a class="text-reset dropdown-btn arrow-none" href="javascript:void(0);"
                                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        ngbDropdownToggle>
                                        <span class="text-muted fs-16"><i
                                                class="mdi mdi-dots-vertical align-middle"></i></span>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="selectDateRange('this-month')">
                                            This Month
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="selectDateRange('last-month')">
                                            Last Month
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="selectDateRange('30-days')">
                                            Past 30 days
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="selectDateRange('90-days')">
                                            Past 90 days
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="selectDateRange('this-year')">
                                            This year
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="selectDateRange('last-year')">
                                            Last Year
                                        </a>

                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="selectDateRange('last-365')">
                                            Last 365 days
                                        </a>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div><!--end col-->

                    <div class="col-sm-auto">

                    </div>

                </div><!--end row-->
            </div>
        </div><!-- end card header -->
    </div><!--end col-->
</div><!--end row-->

<div class="widget-container" *ngIf="summary$ | async as summary">
    <app-stat-widget [title]="'Net Income'" [data]="summary.statement.income"
        [icon]="'fa-light fa-money-bill-trend-up'"></app-stat-widget>
    <app-stat-widget [title]="'Revenue'" [data]="summary.statement.revenue"
        [icon]="'fa-light fa-cash-register'"></app-stat-widget>
    <app-stat-widget [title]="'Expenses'" [data]="summary.statement.expense" [icon]="'fa-light fa-bags-shopping'"
        type="reverse"></app-stat-widget>
</div>


<div class="row">
    <div class="col-md-8">
        <div class="card">
            <div class="card-header align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Recent Transactions</h4>
                <div class="flex-shrink-0">
                    <a routerLink="/accounting/transactions" class="link-cta">View All</a>
                </div>
            </div><!-- end card header -->

            <div class="card-body">
                <div class="table-responsive table-card">
                    <!-- <app-transaction-table [selectable]="false" [transactions]="transactions.data$ | async" -->
                    <app-transaction-table [selectable]="false" [transactions]="(transactions$ | async)!"
                        (onView)="viewTransaction($event)"></app-transaction-table>
                </div>
            </div>
        </div> <!-- .card-->
    </div>
    <div class="col-md-4">
        <app-top-expenses [expenses]="(summary$ | async)?.expenses"></app-top-expenses>
    </div>
</div>